// Sticky ATC bar — wjeżdża gdy #main-add-to-cart wyjeżdża z viewportu.
// Obraz/nazwa/cena renderowane server-side w sticky-atc.php (bez DOM lookupu).

function initStickyAtc() {
  const bar = document.getElementById('sticky-atc');
  const mainBtn = document.getElementById('main-add-to-cart');
  if (!bar || !mainBtn) return;

  const stickyBtn = document.getElementById('sticky-atc-btn');
  if (stickyBtn) {
    stickyBtn.addEventListener('click', () => {
      // Główny przycisk jest wyłączony, dopóki nie ma rozmiaru — samo przekazanie kliknięcia
      // kończyło się wtedy niczym. Otwieramy wybór rozmiaru (na telefonie: dolny arkusz).
      if (mainBtn.disabled) {
        const pole = document.querySelector('form.variations_form .kb-select__trigger');
        if (pole) { pole.click(); return; }
        const select = document.querySelector('form.variations_form select[data-attr-select]');
        if (select) { select.scrollIntoView({ block: 'center', behavior: 'smooth' }); select.focus(); }
        return;
      }
      mainBtn.click();
    });
  }

  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.classList.toggle('kb-sticky-shown', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    });
  }, { threshold: 0 });
  io.observe(mainBtn);
}

if (typeof document !== 'undefined') {
  if (document.readyState !== 'loading') initStickyAtc();
  else document.addEventListener('DOMContentLoaded', initStickyAtc);
}

export {};
